import React from "react";

import ConfirmationPopup from "components/common/ConfirmationPopup";

interface DeleteProtocolModalProps {
  open: boolean;
  type: "protocol" | "instruction" | "procedure";
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const DeleteProtocolModal: React.FC<DeleteProtocolModalProps> = ({
  open,
  type,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const titleMap: Record<typeof type, string> = {
    instruction: "Delete Instruction",
    procedure: "Delete Procedure",
    protocol: "Delete Protocol",
  };
  const messageMap: Record<typeof type, string> = {
    instruction:
      "Are you sure you want to delete this instruction for the patient? This action cannot be undone.",
    procedure:
      "Are you sure you want to delete this procedure for the patient? This action cannot be undone.",
    protocol:
      "Are you sure you want to delete this protocol for the patient? This action cannot be undone.",
  };

  return (
    <ConfirmationPopup
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={titleMap[type]}
      message={messageMap[type]}
      confirmText="Delete"
      cancelText="Cancel"
      confirmColor="#d32f2f"
      loading={loading}
      maxWidth="sm"
      paperSx={{ borderRadius: 4 }}
    />
  );
};

export default DeleteProtocolModal;
